exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.product-page-pdp .productTileBox {\n    margin-top: 0px !important;\n}\n", ""]);

// exports
